import { render, staticRenderFns } from "./headerPublisher.vue?vue&type=template&id=ce489852"
import script from "./headerPublisher.vue?vue&type=script&lang=js"
export * from "./headerPublisher.vue?vue&type=script&lang=js"
import style0 from "./headerPublisher.vue?vue&type=style&index=0&id=ce489852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports